"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var moment = require('moment-business-days');

require('moment-timezone');

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var traverseDecisionTree = require('../util/traverseDecisionTree');

var Shipment = require('./Shipment');

var ShineProducts = require('../products/index');

var Envelope = require('../products/interfaces/Envelope');

var PACKAGE_CONSTANTS = require('../products/constants');

var largePrints = [PACKAGE_CONSTANTS.WELCOME_SIGNS, PACKAGE_CONSTANTS.WELCOME_SIGN_REPRINTS, PACKAGE_CONSTANTS.SEATING_CHARTS, PACKAGE_CONSTANTS.SEATING_CHART_REPRINTS];
var large_product_sizes = ['20x30', '24x36'];

var isLarge = function isLarge(product) {
  return largePrints.includes(product.product_type) || product.components.filter(function (component) {
    return large_product_sizes.includes(component.product_size);
  }).length;
};

function samplesOnly(p) {
  return [PACKAGE_CONSTANTS.SILK_RIBBON_SAMPLES, PACKAGE_CONSTANTS.CLASSIC_WEDDING_INVITATION_SAMPLES, PACKAGE_CONSTANTS.LETTERPRESS_WEDDING_INVITATION_SAMPLES, PACKAGE_CONSTANTS.WEDDING_PLANNER_BOXES].includes(p.product_type);
}

var excludeSamples = function excludeSamples(p) {
  return !samplesOnly(p);
};

function isCustomSample(p) {
  return [PACKAGE_CONSTANTS.CUSTOM_SAMPLES].includes(p.product_type);
}

var excludeCustomSamples = function excludeCustomSamples(p) {
  return !isCustomSample(p);
};

var excludeLargePrints = function excludeLargePrints(p) {
  return !isLarge(p);
};

var includeLargePrints = function includeLargePrints(p) {
  return isLarge(p);
};

function sampleShipByDate(order) {
  // if a sample comes in before 8am, it can ship by end-of-day today.
  // Otherwise, it ships by end-of-day tomorrow.
  var date = moment(order.order_date);

  if (date.tz('America/New_York').hours() >= 8) {
    date = date.businessAdd(1, 'day');
  }

  while (!date.isBusinessDay()) {
    date = date.businessAdd(1, 'day');
  }

  return date.hours(17).minutes(0).seconds(0).milliseconds(0);
}

function calculateShipDate(order, userOpts, settings) {
  var variant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'digital';
  var cutoffDecisionTree = settings.shipByDateCutoff[variant];
  var daysToAddDecisionTree = settings.shipByDate.internal[variant];

  if (userOpts.clientFacing) {
    daysToAddDecisionTree = settings.shipByDate.clientFacing[variant];
  }

  var cutoff = traverseDecisionTree(order, cutoffDecisionTree);
  var days_to_add = traverseDecisionTree(order, daysToAddDecisionTree);
  var now = order.approved_on_date ? moment(order.approved_on_date) : moment(); // if Sat or Sun, cutoff does not matter
  // but we need to compensate for the difference in business days.

  if (now.format('dddd') === 'Saturday' || now.format('dddd') === 'Sunday') {
    days_to_add += 1;
  } else if (now.tz('America/New_York').hours() >= cutoff) {
    days_to_add += 1;
  }

  if (order.needs_assembly) {
    days_to_add += 5;
  }

  return now.businessAdd(days_to_add, 'days').hours(17).minutes(0).seconds(0).milliseconds(0).toISOString();
}

function calculateCustomSamplesShipDate(order, userOpts, settings) {
  var variant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'digital';
  var cutoffDecisionTree = settings.shipByDateCutoff[variant];
  var daysToAddDecisionTree = settings.shipByDate.internal[variant];

  if (userOpts.clientFacing) {
    daysToAddDecisionTree = settings.shipByDate.clientFacing[variant];
  }

  var cutoff = traverseDecisionTree(order, cutoffDecisionTree);
  var days_to_add = traverseDecisionTree(order, daysToAddDecisionTree);
  var now = moment(); // if Sat or Sun, cutoff does not matter
  // but we need to compensate for the difference in business days.

  if (now.format('dddd') === 'Saturday' || now.format('dddd') === 'Sunday') {
    days_to_add += 1;
  } else if (now.tz('America/New_York').hours() >= cutoff) {
    days_to_add += 1;
  }

  return now.businessAdd(days_to_add, 'days').hours(17).minutes(0).seconds(0).milliseconds(0).toISOString();
}
/**
 * the algorithm for deciding what kind of shipments an order requires
 * @param {Order} order
 * @param {*} userOpts
 * @param {*} settings
 * @returns {Array<Shipment>}
 */


function defaultShipments(order) {
  var userOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var settings = arguments.length > 2 ? arguments[2] : undefined;
  // const internationalLetterpressShippingAddress = settings.warehouses.shineWarehouse.returnAddress;
  // get Pistachio Press address from settings
  var letterpressShippingAddress = settings.letterpressShippingAddress;
  var shipments = [];
  var sampleProducts = [];
  var customSampleProducts = [];
  var smallProducts = [];

  if (order.designations.includes('orders') || order.designations.includes('table_numbers') || order.designations.includes('custom_samples')) {
    sampleProducts = order.products.filter(samplesOnly);
    customSampleProducts = order.products.filter(isCustomSample);
    smallProducts = order.products.filter(excludeCustomSamples).filter(excludeSamples).filter(excludeLargePrints);
  } else {
    // sometimes wax seals / vellum jackets / ribbon spools go with sample shipments
    sampleProducts = order.products.filter(excludeLargePrints);
  }

  var largeProducts = order.products.filter(excludeSamples).filter(includeLargePrints);
  var smallShipmentAddress = order[order.small_shipment_shipping_address] || order.primary_shipping_address;
  var letterpressShipmentAddress = order[order.letterpress_shipment_shipping_address] || order.primary_shipping_address;
  var largeShipmentAddress = order[order.large_shipment_shipping_address] || order.primary_shipping_address;
  var envelopeShipmentAddress = order[order.envelopes_shipment_shipping_address] || order.primary_shipping_address;
  var digitalShipByDate = userOpts.ship_by_date && userOpts.ship_by_date.digital || calculateShipDate(order, userOpts, settings);
  var letterpressShipByDate = userOpts.ship_by_date && userOpts.ship_by_date.letterpress || calculateShipDate(order, userOpts, settings, 'letterpress');
  var customSampleShipByDate = calculateCustomSamplesShipDate(order, userOpts, settings);
  var customerFacingDigitalShipByDate = userOpts.customer_ship_by_date && userOpts.customer_ship_by_date.digital || calculateShipDate(order, _objectSpread(_objectSpread({}, userOpts), {}, {
    clientFacing: true
  }), settings);
  var customerFacingLetterpressShipByDate = userOpts.customer_ship_by_date && userOpts.customer_ship_by_date.letterpress || calculateShipDate(order, _objectSpread(_objectSpread({}, userOpts), {}, {
    clientFacing: true
  }), settings, 'letterpress');
  var customerFacingCustomSampleShipByDate = calculateCustomSamplesShipDate(order, _objectSpread(_objectSpread({}, userOpts), {}, {
    clientFacing: true
  }), settings); // Create a shipment

  var shipment_id = order.oid || order.id;
  var tsz = moment().format('X');
  var activeNotes = order.notes.filter(function (_ref) {
    var active = _ref.active;
    return active;
  });

  if (sampleProducts.length) {
    var newSampleShipment = new Shipment(_objectSpread({
      designation: 'sample_shipment',
      origin: 'printingPlus',
      shipping_address: smallShipmentAddress,
      name: order.customer_name,
      ship_by_date: sampleShipByDate(order),
      products: sampleProducts,
      id: "".concat(shipment_id, "-sp-").concat(tsz),
      order_id: order.id,
      email: order.email,
      service: order.shipping_service,
      notes: activeNotes.filter(function (_ref2) {
        var designation = _ref2.designation;
        return designation === 'sample_shipment';
      })
    }, userOpts.sample_shipment));
    shipments.push(newSampleShipment);
  }

  if (customSampleProducts.length) {
    var newCustomSampleShipment = new Shipment(_objectSpread({
      designation: 'custom_sample_shipment',
      origin: 'printingPlus',
      shipping_address: smallShipmentAddress,
      name: order.customer_name,
      ship_by_date: customSampleShipByDate,
      customer_ship_by_date: customerFacingCustomSampleShipByDate,
      products: customSampleProducts,
      id: "".concat(shipment_id, "-csp-").concat(tsz),
      order_id: order.id,
      email: order.email,
      service: order.shipping_service,
      notes: activeNotes.filter(function (_ref3) {
        var designation = _ref3.designation;
        return designation === 'custom_sample_shipment';
      })
    }, userOpts.sample_shipment));
    shipments.push(newCustomSampleShipment);
  }

  if (parseBoolean(order.has_letterpress)) {
    // order is now a shipment from PrintingPlus to PistachioPress (as of 02/18/2019)
    var smallProductsMinusLetterpressComponents = smallProducts.map(function (prod) {
      var copy_of_product = ShineProducts.instance().make(JSON.parse(JSON.stringify(prod)));
      copy_of_product.components = copy_of_product.components.filter(function (_ref4) {
        var component_type = _ref4.component_type;
        return !component_type.match(/letterpress/i);
      });
      return copy_of_product;
    }); // special case:

    var alt_shipping_service = order.shipping_service;

    if (order.is_international) {
      if (order.printing_type === 'RUSH') {
        alt_shipping_service = 'One Day Shipping';
      } else {
        alt_shipping_service = 'Standard Shipping';
      }
    } else if (order.printing_type === 'RUSH' && order.shipping_service.match(/priority/i)) {
      alt_shipping_service = 'Two Day Shipping';
    }

    if (smallProductsMinusLetterpressComponents.some(function (product) {
      return product.components.length;
    })) {
      shipments.push(new Shipment(_objectSpread({
        email: 'hello@shineweddinginvitations.com',
        ship_by_date: digitalShipByDate,
        customer_ship_by_date: customerFacingDigitalShipByDate,
        shipping_address: letterpressShippingAddress,
        name: order.customer_name,
        designation: 'small_shipment',
        origin: 'printingPlus',
        show_to_customer: false,
        needs_assembly: order.needs_assembly,
        products: smallProductsMinusLetterpressComponents,
        id: "".concat(shipment_id, "-sm-").concat(tsz),
        order_id: order.id,
        service: alt_shipping_service,
        notes: activeNotes.filter(function (_ref5) {
          var designation = _ref5.designation;
          return designation === 'small_shipment';
        })
      }, userOpts.small_shipment)));
    } // from Pistachio to customer


    shipments.push(new Shipment(_objectSpread({
      id: "".concat(shipment_id, "-lp-").concat(tsz),
      designation: 'letterpress_shipment',
      shipping_address: letterpressShipmentAddress,
      name: order.customer_name,
      ship_by_date: letterpressShipByDate || moment(),
      customer_ship_by_date: customerFacingLetterpressShipByDate || moment(),
      products: smallProducts,
      origin: 'pistachioPress',
      needs_assembly: order.needs_assembly,
      order_id: order.id,
      email: order.email,
      service: order.shipping_service,
      notes: activeNotes.filter(function (_ref6) {
        var designation = _ref6.designation;
        return designation === 'letterpress_shipment';
      })
    }, userOpts.letterpress_shipment)));
  } else if (smallProducts.length) {
    shipments.push(new Shipment(_objectSpread({
      designation: 'small_shipment',
      origin: 'printingPlus',
      shipping_address: smallShipmentAddress,
      name: order.customer_name,
      ship_by_date: digitalShipByDate,
      customer_ship_by_date: customerFacingDigitalShipByDate,
      products: smallProducts,
      needs_assembly: order.needs_assembly,
      id: "".concat(shipment_id, "-sm-").concat(tsz),
      order_id: order.id,
      email: order.email,
      notes: activeNotes.filter(function (_ref7) {
        var designation = _ref7.designation;
        return designation === 'small_shipment';
      }),
      service: order.shipping_service
    }, userOpts.small_shipment)));
  }

  if (largeProducts.length) {
    shipments.push(new Shipment(_objectSpread({
      shipping_address: largeShipmentAddress,
      name: order.customer_name,
      ship_by_date: digitalShipByDate,
      customer_ship_by_date: customerFacingDigitalShipByDate,
      origin: 'printingPlus',
      designation: 'large_shipment',
      products: largeProducts,
      service: order.shipping_service,
      id: "".concat(shipment_id, "-lg-").concat(tsz),
      order_id: order.id,
      email: order.email,
      notes: activeNotes.filter(function (_ref8) {
        var designation = _ref8.designation;
        return designation === 'large_shipment';
      })
    }, userOpts.large_shipment)));
  }

  if (order.ship_envelopes_separately) {
    var envelopes = [];
    smallProducts.forEach(function (product) {
      var newProduct = ShineProducts.instance().envelopes.make();
      var shouldAdd = false;
      product.subcomponents().forEach(function (component) {
        if (Object.prototype.isPrototypeOf.call(Envelope.prototype, component) && component.ships_separately) {
          shouldAdd = true;
          var newComponentRef;

          switch (component.name) {
            case 'A7Envelope':
              newComponentRef = newProduct.a7Envelopes;
              break;

            case 'A75Envelope':
              newComponentRef = newProduct.a75Envelopes;
              break;

            case 'ResponseCardEnvelope':
              newComponentRef = newProduct.responseCardEnvelopes;
              break;

            case 'ThankYouCardEnvelope':
              newComponentRef = newProduct.thankYouCardEnvelopes;
              break;

            case 'SaveTheDateEnvelope':
              newComponentRef = newProduct.saveTheDatEnvelopes;
              break;

            default:
              throw new Error("".concat(component.name, " did not match an envelope type"));
          }

          if (newComponentRef) {
            var design_name = product.design_name,
                paper_type = product.paper_type,
                ink_colors = product.ink_colors,
                letterpress_ink_colors = product.letterpress_ink_colors; // apply the corresponding product's parameters to this one.

            newProduct.set({
              design_name: design_name,
              paper_type: paper_type,
              ink_colors: ink_colors,
              letterpress_ink_colors: letterpress_ink_colors
            }); // add the envelope component

            newComponentRef.add(JSON.parse(JSON.stringify(component)));
          }
        }
      });

      if (shouldAdd) {
        envelopes.push(newProduct);
      }
    });

    if (envelopes.length) {
      shipments.push(new Shipment(_objectSpread({
        id: "".concat(shipment_id, "-en-").concat(tsz),
        shipping_address: envelopeShipmentAddress,
        name: order.customer_name,
        order_id: order.id,
        email: order.email,
        origin: 'printingPlus',
        designation: 'envelopes_shipment',
        ship_by_date: digitalShipByDate || moment(),
        customer_ship_by_date: customerFacingDigitalShipByDate || moment(),
        service: order.shipping_service,
        products: envelopes,
        notes: activeNotes.filter(function (_ref9) {
          var designation = _ref9.designation;
          return designation === 'envelopes_shipment';
        })
      }, userOpts.envelopes_shipment)));
    }
  }

  if (shipments.length === 1 && shipments[0].designation === 'small_shipment' && shipments[0].products.length === 1 && shipments[0].products[0].product_type === PACKAGE_CONSTANTS.LINER_SAMPLES) {
    shipments[0].designation = 'liner_samples_shipment';
  }

  return shipments;
}

module.exports = defaultShipments;